import e, { useState as b, useEffect as N } from "react";
import { PaymentSelector as ce } from "./index202.mjs";
import { useAtomValue as p, useSetAtom as D } from "jotai";
import K from "./index79.mjs";
import { cartItemsAtom as le, giftCardsAtom as me, giftCardCodeAtom as H, roomsAvailabilityAtom as se } from "./index34.mjs";
import { selectedClientDetailsAtom as de } from "./index55.mjs";
import { setBookingSummaryShowAtom as ue } from "./index25.mjs";
import { insurancePriceAtom as F, insuranceSelectedAtom as _e } from "./index62.mjs";
import { formatPrice as x } from "./index110.mjs";
import { shouldShowCityTaxItem as R, getValidCityTaxAmount as B } from "./index117.mjs";
import t from "./index203.mjs";
import { getDaysDifference as M, formatDate as G, DATE_FORMATS as O } from "@amenitiz/design-system";
import { useErrorAlert as ge } from "./index121.mjs";
import { calculateTotalPrice as C } from "./index111.mjs";
import { useTracking as pe } from "./index88.mjs";
import { CHECKOUT_PAGE_HASH as fe } from "./index87.mjs";
import { track as Ee } from "./index9.mjs";
import { TRACK_EVENT_TYPE as he, TRACK_EVENT as ye } from "./index10.mjs";
import { useHotelConfig as Ie } from "./index93.mjs";
import { getSubscriptionPlanRoot as ke } from "./index14.mjs";
import { useSalesTermsAndConditions as be } from "./index102.mjs";
import { Insurance as Ne } from "./index204.mjs";
import { ValidateCode as ve } from "./index95.mjs";
import Ce from "./index205.mjs";
import Te from "./index206.mjs";
import Se from "./index207.mjs";
import $e from "./index184.mjs";
const Pe = ({
  cartItem: n,
  roomsAvailability: a
}) => {
  const r = `${I18n.t(
    `booking_engine.information.adults.${n.totalAdults === 1 ? "one" : "other"}`,
    { count: n.totalAdults.toString() }
  )}`, d = `${I18n.t(
    `booking_engine.information.children.${n.totalChildren === 1 ? "one" : "other"}`,
    { count: n.totalChildren.toString() }
  )}`, l = n.totalChildren > 0 ? `${r}, ${d}` : r;
  return /* @__PURE__ */ e.createElement("div", { className: t.stay_info_card, "data-testid": "cart-item" }, /* @__PURE__ */ e.createElement("div", { className: t.stay_header, "data-testid": "cart-title" }, I18n.t("booking_engine.information.your_stay")), /* @__PURE__ */ e.createElement("div", { className: t.stay_details }, /* @__PURE__ */ e.createElement("div", { className: t.stay_detail_row }, /* @__PURE__ */ e.createElement(Ce, null), /* @__PURE__ */ e.createElement("div", { className: t.date_details_container }, /* @__PURE__ */ e.createElement("div", { className: t.date_details }, /* @__PURE__ */ e.createElement("div", { className: t.date_check_in, "data-testid": "check-in-time" }, I18n.t("booking_engine.room.check_in"), ":"), /* @__PURE__ */ e.createElement("div", { className: t.date }, G(O.EU, n.arrivalDate)), a.showCheckInCheckOutTime ? /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "check-in-time-description",
      className: t.time
    },
    I18n.t("booking_engine.results.rate.from"),
    " ",
    a.checkInTime,
    " ",
    I18n.t("booking_engine.room.to"),
    " ",
    a.checkInEndTime
  ) : null), /* @__PURE__ */ e.createElement("div", { className: t.date_details }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: t.date_check_in,
      "data-testid": "check-out-time"
    },
    I18n.t("booking_engine.room.check_out"),
    ":"
  ), /* @__PURE__ */ e.createElement("div", { className: t.date }, G(O.EU, n.departureDate)), a.showCheckInCheckOutTime ? /* @__PURE__ */ e.createElement("div", { className: t.time }, I18n.t("booking_engine.results.rate.from"), " ", a.checkOutTime, " ", I18n.t("booking_engine.room.to"), " ", a.checkOutEndTime) : null))), a.checkInInfo ? /* @__PURE__ */ e.createElement("div", { className: t.instructions }, /* @__PURE__ */ e.createElement(Se, { className: t.instructions_icon }), /* @__PURE__ */ e.createElement("div", null, a.checkInInfo)) : null, /* @__PURE__ */ e.createElement("div", { className: t.guests_row }, /* @__PURE__ */ e.createElement(Te, null), /* @__PURE__ */ e.createElement("div", { "data-testid": "capacity-amount" }, l))));
}, Ae = ({
  items: n,
  currency: a,
  totalPrice: r,
  insuranceSelected: d,
  insurancePrice: l,
  giftCardAmountApplied: m,
  salesTerms: E
}) => {
  if (!n || n.length === 0)
    return null;
  const h = E ? /* @__PURE__ */ e.createElement("div", { className: t.rate_type_tags }, E.modifiable ? /* @__PURE__ */ e.createElement("span", { className: `${t.tag} ${t.modifiable}` }, I18n.t("booking_engine.results.rate.modifiable")) : /* @__PURE__ */ e.createElement("span", { className: `${t.tag} ${t.non_refundable}` }, I18n.t("booking_engine.results.rate.non_modifiable")), E.cancellable ? /* @__PURE__ */ e.createElement("span", { className: `${t.tag} ${t.modifiable}` }, I18n.t("booking_engine.results.rate.cancellable")) : /* @__PURE__ */ e.createElement("span", { className: `${t.tag} ${t.non_refundable}` }, I18n.t("booking_engine.results.rate.non_cancellable"))) : null;
  return /* @__PURE__ */ e.createElement("div", { className: t.accommodation_card, "data-testid": "accommodation-card" }, n.map((o, s) => /* @__PURE__ */ e.createElement(e.Fragment, { key: o.id }, /* @__PURE__ */ e.createElement("div", { className: t.accommodation_header }, /* @__PURE__ */ e.createElement("div", { className: t.accommodation_title }, /* @__PURE__ */ e.createElement("span", { className: t.accommodation_title_number }, `${I18n.t("booking_engine.room")} ${s + 1}: `), /* @__PURE__ */ e.createElement("span", { "data-testid": `room-name-${s}` }, o.roomName)), /* @__PURE__ */ e.createElement("div", { className: t.accommodation_pricing_details }, /* @__PURE__ */ e.createElement("div", { className: t.accommodation_type }, o.pricingTypeName), h)), /* @__PURE__ */ e.createElement("div", { className: t.accommodation_details }, /* @__PURE__ */ e.createElement(
    f,
    {
      label: I18n.t("booking_engine.information.nights", {
        count: M(
          o.arrivalDate,
          o.departureDate
        ).toString()
      }),
      amount: parseFloat(o.totalPrice),
      currency: a,
      testId: `room-price-${s}`
    }
  ), R(o.cityTaxIncluded, o.cityTaxes) ? /* @__PURE__ */ e.createElement(
    f,
    {
      label: I18n.t("booking_engine.information.city_tax"),
      amount: B(o.cityTaxes),
      currency: a,
      testId: "extra-name-3"
    }
  ) : null, o.optionalExtras.map((i, y) => /* @__PURE__ */ e.createElement(
    f,
    {
      key: i.id,
      label: `${i.amount} ${i.name}`,
      amount: parseFloat(i.total_price),
      currency: a,
      testId: `extra-name-${y}`
    }
  )), o.mandatoryExtras.map((i, y) => /* @__PURE__ */ e.createElement(
    f,
    {
      key: i.id,
      label: `${i.amount} ${i.name}`,
      amount: parseFloat(i.total_price),
      currency: a,
      testId: `extra-name-${y + o.optionalExtras.length}`
    }
  ))))), r ? /* @__PURE__ */ e.createElement("div", { className: t.accommodation_totals }, /* @__PURE__ */ e.createElement("div", { className: t.divider }), d && l ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    f,
    {
      "data-testid": "insurance-price",
      label: I18n.t("booking_engine.information.insurance_label"),
      amount: parseFloat(l),
      currency: a
    }
  ), /* @__PURE__ */ e.createElement("div", { className: t.divider })) : null, (m ?? 0) > 0 ? /* @__PURE__ */ e.createElement(
    f,
    {
      label: I18n.t("booking_engine.information.gift_card_applied"),
      amount: -(m ?? 0),
      currency: a,
      testId: "gift-card-summary"
    }
  ) : null, /* @__PURE__ */ e.createElement(
    f,
    {
      label: I18n.t("booking_engine.room.total"),
      amount: parseFloat(r),
      currency: a,
      isTotal: !0,
      className: t.price_item_total
    }
  )) : null);
}, f = ({
  label: n,
  amount: a,
  currency: r,
  isTotal: d = !1,
  className: l = t.price_item,
  testId: m
}) => /* @__PURE__ */ e.createElement("div", { className: l, "data-testid": m }, d ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("strong", null, n), /* @__PURE__ */ e.createElement("strong", null, x(a, r))) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("span", null, n), /* @__PURE__ */ e.createElement("span", null, x(a, r)))), we = ({
  clientBookingToken: n
}) => /* @__PURE__ */ e.createElement("div", { className: t.gift_card_container }, /* @__PURE__ */ e.createElement("div", { className: t.gift_card_header }, I18n.t("booking_engine.information.gift_card.discounts")), /* @__PURE__ */ e.createElement("div", { className: t.gift_card_input }, /* @__PURE__ */ e.createElement("div", { className: t.gift_card_label }, I18n.t("booking_engine.information.gift_card.title")), /* @__PURE__ */ e.createElement(
  ve,
  {
    codeAtom: H,
    validateCode: (a) => K.validateGiftCard(a, n),
    icon: /* @__PURE__ */ e.createElement($e, null),
    translationKey: "booking_engine.information.gift_card.code",
    customClasses: t.gift_card_form
  }
))), it = () => {
  var $, P;
  pe(fe);
  const n = p(le), a = p(me), r = p(H), [d, l] = b(!1), m = D(ue), E = D(F), h = p(se), o = p(_e), s = p(F), i = ge(), y = p(de), [U, V] = b(!0), [q, L] = b(0), [z, v] = b("0.00"), [T, W] = b(null), {
    hotelId: Y,
    hotelName: j,
    propertySize: J,
    propertyType: Q,
    subscriptionPlan: X,
    clientBookingToken: Z
  } = Ie(), { salesTermsAndConditions: u, setSalesTermsAndConditions: S } = be(), ee = n.length ? M(n[0].arrivalDate, /* @__PURE__ */ new Date()) < 2 : !1;
  N(() => {
    var w;
    if (!n.length)
      return;
    const c = C({
      cartItems: n,
      insurancePrice: o ? s : "0"
    });
    n[0].insuranceEligible && l(!0);
    const k = () => {
      let I = 1;
      return n.flatMap((_) => {
        const oe = {
          item_name: _.roomName,
          item_id: I++,
          price: parseFloat(_.totalPrice),
          item_type: "Room",
          quantity: "1"
        }, ie = [
          ..._.optionalExtras.map((g) => ({
            item_name: g.name,
            item_id: I++,
            price: parseFloat(g.total_price),
            item_type: "Optional Extra",
            quantity: g.amount
          })),
          ..._.mandatoryExtras.map((g) => ({
            item_name: g.name,
            item_id: I++,
            price: parseFloat(g.total_price),
            item_type: "Mandatory Extra",
            quantity: g.amount
          }))
        ], re = R(
          _.cityTaxIncluded,
          _.cityTaxes
        ) ? [
          {
            item_name: "City Tax",
            item_id: I++,
            price: B(_.cityTaxes),
            item_type: "City Tax",
            quantity: "1"
          }
        ] : [];
        return [oe, ...ie, ...re];
      });
    };
    if (v(c), !u)
      return;
    const A = (w = u == null ? void 0 : u.payment_methods) == null ? void 0 : w.map(
      (I) => I[0]
    );
    Ee(ye.BEGIN_CHECKOUT, he.BEGIN_CHECKOUT, {
      hotel_id: Y,
      property_type: Q,
      property_size: J,
      subscription_plan: ke(X),
      payment_methods: A,
      num_payment_methods_available: A.length,
      insurance_available: n[0].insuranceEligible ? "yes" : "no",
      ecommerce: {
        currency: h.currency,
        value: c,
        items: k()
      }
    });
  }, [n]), N(() => {
    if (!a.length)
      return;
    const c = C({ giftCards: a });
    v(c);
  }, [a]), N(() => {
    if (!n.length)
      return;
    const c = C({
      cartItems: n,
      insurancePrice: o ? s : "0"
    });
    v(c);
  }, [n, o, s]), N(() => (m(!1), () => {
    m(!0);
  }), [m]), N(() => {
    K.getPaymentInformation({
      ...n.length ? { items: n } : null,
      ...a.length ? { gift_cards: a } : null,
      customer: y,
      gift_card_code: r
    }).then(({ data: c }) => {
      S(c), v(c.total_amount.toString()), L(c.redeem_gift_card);
      const k = c.sales_terms.insurance_information;
      k && (W(k), E(k.price || "")), V(!1);
    }).catch(() => {
      i();
    });
  }, [
    n,
    i,
    E,
    S,
    a,
    y,
    r
  ]);
  const te = () => n.length ? /* @__PURE__ */ e.createElement(
    Pe,
    {
      cartItem: n[0],
      roomsAvailability: h
    }
  ) : null, ne = () => n.length ? /* @__PURE__ */ e.createElement(
    Ae,
    {
      items: n,
      currency: h.currency,
      totalPrice: z,
      insuranceSelected: o,
      insurancePrice: s,
      giftCardAmountApplied: q,
      salesTerms: u == null ? void 0 : u.sales_terms
    }
  ) : null, ae = () => U ? /* @__PURE__ */ e.createElement("div", { className: t.cart_item, "data-testid": "selector-loading" }, I18n.t("booking_engine.information.stripe_loading")) : /* @__PURE__ */ e.createElement("div", { className: t.payment_methods }, /* @__PURE__ */ e.createElement("div", { className: t.payment_methods_title }, I18n.t("booking_engine.information.payment_method.label")), /* @__PURE__ */ e.createElement(ce, { cartItems: n, giftCards: a }));
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      id: "payment-step",
      "data-testid": "payment-step",
      className: t.booking_summary
    },
    te(),
    d && T ? /* @__PURE__ */ e.createElement(
      Ne,
      {
        insuranceInformation: T,
        isLessThanTwoDays: ee,
        currency: h.currency
      }
    ) : null,
    a.length ? null : /* @__PURE__ */ e.createElement(we, { clientBookingToken: Z }),
    ne(),
    ae(),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: t.booking_legal_notice,
        "data-testid": "booking-legal-notice"
      },
      I18n.t("booking_engine.information.booking_forms_desc", {
        booking_engine_hotel_name: j,
        website_url: (P = ($ = window == null ? void 0 : window.document) == null ? void 0 : $.location) == null ? void 0 : P.host
      })
    )
  );
};
export {
  it as PaymentStep
};
